import React, { PropsWithChildren } from "react";
import BackgroundCornerImage from '../../../../assets/background.png';

import { TailSpin } from "../Loader/TailSpin";

type ScreenContainerProps = {
  loading?: boolean;
  className?: string;
  error?: React.ReactNode;
  renderContext?: React.ReactNode;
};

const ScreenContainer: React.FC<PropsWithChildren<ScreenContainerProps>> = ({
  renderContext = null,
  loading = false,
  error,
  className,
  children,
}) => {
  return (
    <>
      <div
        className="flex-grow overflow-y-auto bg-fixed bg-white bg-right-bottom bg-no-repeat text-dark-100"
        style={{
          backgroundImage: `url(${BackgroundCornerImage})`
        }}
      >
        {loading ? (
          <div
            className={`flex min-h-layout`}
          >
            <div className="flex flex-col items-center justify-center flex-grow">
              <TailSpin className="w-20 h-20 text-primary-500" />
            </div>
          </div>
        ) : (
          <div
            className={`min-h-layout ${className}`}
          >
            {error ? error : children}
          </div>
        )}
      </div>
      {renderContext && (
        <div className="flex-shrink-0 overflow-y-auto w-80">
          {renderContext}
        </div>
      )}
    </>
  );
};

export default React.memo(ScreenContainer);
